import { useQuery } from "@tanstack/react-query";
import { ApiBalance } from "@/shared/api/balance/api-balance";

const apiBalance = new ApiBalance();

export const useGetTopUpInfo = ({
  topUpId,
  enabled,
}: {
  topUpId: string | null;
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: ["top-up-info", topUpId],
    queryFn: () => {
      if (!topUpId) {
        throw new Error("topUpId is required");
      }
      return apiBalance.getTopUpInfo(topUpId).then((res) => res.data);
    },
    enabled: !!topUpId && enabled,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      const isFinal = status === "succeeded" || status === "cancelled";
      return isFinal ? false : 2000;
    },
    refetchOnWindowFocus: false,
  });
};
